"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeRenewalDeclineText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var HomeRenewalDeclineText = /** @class */ (function (_super) {
    __extends(HomeRenewalDeclineText, _super);
    function HomeRenewalDeclineText(props) {
        var _this = _super.call(this, props) || this;
        _this.ageOfProposerDeclineText = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we're unable to give you a renewal quote for ", _this.props.customerAddress, " because of your age."] });
        _this.genericDeclineText = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we're unable to give you a renewal quote for ", _this.props.customerAddress, " because our underwriting criteria is no longer being met and we are now no longer able to provide insurance for this property."] });
        _this.convictionDeclineText = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we're unable to give you a renewal quote for ", _this.props.customerAddress, " because you, or someone who lives with you has a conviction."] });
        _this.structuralWorkDeclineText = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we're unable to give you a renewal quote for ", _this.props.customerAddress, " because the property is undergoing structural work."] });
        _this.mainResidenceDeclineText = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we're unable to give you a renewal quote for ", _this.props.customerAddress, " because the property isn't your main residence."] });
        _this.claimsDeclineText = (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry, we're unable to give you a renewal quote for ", _this.props.customerAddress, " because of your claims history."] });
        _this.unableToRenewDeclineText = (0, jsx_runtime_1.jsx)("p", { children: "Unfortunately, we are unable to renew your policy. " });
        _this.northernIrelandAddressDeclineText = (0, jsx_runtime_1.jsx)("p", { children: "Cover unacceptable due to Northern Ireland." });
        _this.underwritingResultCustomerWordings = [
            {
                key: "UWH001",
                value: _this.ageOfProposerDeclineText
            },
            {
                key: "UWH002",
                value: _this.ageOfProposerDeclineText
            },
            {
                key: "UWH003",
                value: _this.genericDeclineText
            },
            {
                key: "UWH004",
                value: _this.genericDeclineText
            },
            {
                key: "UWH005",
                value: _this.genericDeclineText
            },
            {
                key: "UWH006",
                value: _this.convictionDeclineText
            },
            {
                key: "UWH007",
                value: _this.genericDeclineText
            },
            {
                key: "UWH008",
                value: _this.genericDeclineText
            },
            {
                key: "UWH009",
                value: _this.genericDeclineText
            },
            {
                key: "UWH010",
                value: _this.genericDeclineText
            },
            {
                key: "UWH011",
                value: _this.genericDeclineText
            },
            {
                key: "UWH012",
                value: _this.genericDeclineText
            },
            {
                key: "UWH013",
                value: _this.genericDeclineText
            },
            {
                key: "UWH014",
                value: _this.structuralWorkDeclineText
            },
            {
                key: "UWH015",
                value: _this.genericDeclineText
            },
            {
                key: "UWH016",
                value: _this.genericDeclineText
            },
            {
                key: "UWH017",
                value: _this.genericDeclineText
            },
            {
                key: "UWH018",
                value: _this.genericDeclineText
            },
            {
                key: "UWH019",
                value: _this.genericDeclineText
            },
            {
                key: "UWH020",
                value: _this.mainResidenceDeclineText
            },
            {
                key: "UWH021",
                value: _this.mainResidenceDeclineText
            },
            {
                key: "UWH022",
                value: _this.genericDeclineText
            },
            {
                key: "UWH023",
                value: _this.genericDeclineText
            },
            {
                key: "UWH028",
                value: _this.genericDeclineText
            },
            {
                key: "UWH029",
                value: _this.genericDeclineText
            },
            {
                key: "UWH030",
                value: _this.genericDeclineText
            },
            {
                key: "UWH031",
                value: _this.genericDeclineText
            },
            {
                key: "UWH032",
                value: _this.genericDeclineText
            },
            {
                key: "UWH033",
                value: _this.genericDeclineText
            },
            {
                key: "UWH034",
                value: _this.genericDeclineText
            },
            {
                key: "UWH035",
                value: _this.genericDeclineText
            },
            {
                key: "UWH036",
                value: _this.genericDeclineText
            },
            {
                key: "UWH037",
                value: _this.genericDeclineText
            },
            {
                key: "UWH038",
                value: _this.genericDeclineText
            },
            {
                key: "UWH039",
                value: _this.genericDeclineText
            },
            {
                key: "UWH040",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH041",
                value: _this.genericDeclineText
            },
            {
                key: "UWH042",
                value: _this.genericDeclineText
            },
            {
                key: "UWH044",
                value: _this.genericDeclineText
            },
            {
                key: "UWH045",
                value: _this.genericDeclineText
            },
            {
                key: "UWH048",
                value: _this.genericDeclineText
            },
            {
                key: "UWH049",
                value: _this.genericDeclineText
            },
            {
                key: "UWH051",
                value: _this.genericDeclineText
            },
            {
                key: "UWH052",
                value: _this.genericDeclineText
            },
            {
                key: "UWH053",
                value: _this.genericDeclineText
            },
            {
                key: "UWH054",
                value: _this.genericDeclineText
            },
            {
                key: "UWH055",
                value: _this.genericDeclineText
            },
            {
                key: "UWH056",
                value: _this.genericDeclineText
            },
            {
                key: "UWH057",
                value: _this.genericDeclineText
            },
            {
                key: "UWH058",
                value: _this.genericDeclineText
            },
            {
                key: "UWH059",
                value: _this.genericDeclineText
            },
            {
                key: "UWH060",
                value: _this.genericDeclineText
            },
            {
                key: "UWH061",
                value: _this.genericDeclineText
            },
            {
                key: "UWH062",
                value: _this.mainResidenceDeclineText
            },
            {
                key: "UWH063",
                value: _this.genericDeclineText
            },
            {
                key: "UWH064",
                value: _this.genericDeclineText
            },
            {
                key: "UWH066",
                value: _this.genericDeclineText
            },
            {
                key: "UWH067",
                value: _this.unableToRenewDeclineText
            },
            {
                key: "UWH068",
                value: _this.genericDeclineText
            },
            {
                key: "UWH069",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH070",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH071",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH072",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH073",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH074",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH075",
                value: _this.claimsDeclineText
            },
            {
                key: "UWH076",
                value: _this.genericDeclineText
            },
            {
                key: "UWH077",
                value: _this.genericDeclineText
            },
            {
                key: "UWH078",
                value: _this.genericDeclineText
            },
            {
                key: "UWH079",
                value: _this.genericDeclineText
            },
            {
                key: "UWH080",
                value: _this.genericDeclineText
            },
            {
                key: "UWH081",
                value: _this.genericDeclineText
            },
            {
                key: "UWH082",
                value: _this.northernIrelandAddressDeclineText
            },
            {
                key: "UWH083",
                value: _this.genericDeclineText
            },
            {
                key: "UWH099",
                value: _this.unableToRenewDeclineText
            },
        ];
        return _this;
    }
    HomeRenewalDeclineText.prototype.render = function () {
        var declineMessage;
        if (this.props.underwritingResult.length > 1) {
            declineMessage = this.genericDeclineText;
        }
        else {
            for (var _i = 0, _a = this.underwritingResultCustomerWordings; _i < _a.length; _i++) {
                var underwritingRule = _a[_i];
                if (this.props.underwritingResult[0].objectName === underwritingRule.key) {
                    declineMessage = underwritingRule.value;
                }
            }
        }
        return declineMessage || this.genericDeclineText;
    };
    return HomeRenewalDeclineText;
}(React.Component));
exports.HomeRenewalDeclineText = HomeRenewalDeclineText;
//# sourceMappingURL=HomeRenewalDeclineText.js.map